import React from 'react'
import Tooltip from '@8x8/oxygen-tooltip'
import { translate } from '~/core/translate'

const MauTooltip = ({ children }) => (
  <Tooltip title={translate('mau_details')}>
    {children || 'MAU'}
  </Tooltip>
)

export default MauTooltip
